import adminRequest from '../../adminRequest'
import {themeLogo} from '../../endpoints'
import {headerLogoOf} from './themeLogoUtils'

export {headerLogoOf}

export default class themeLogoApi {
  static async getMatDefaultLogo(matId) {
    return adminRequest({url: themeLogo.getMatDefaultLogo(matId), method: 'GET'})
  }

  static async getSchoolDefaultLogo(schoolId) {
    return adminRequest({url: themeLogo.getSchoolDefaultLogo(schoolId), method: 'GET'})
  }

  // Resolve the effective default logo file for a survey: prefer the school's own
  // logo, falling back to the trust/MAT logo. Returns the HeaderLogo file name, or ''.
  static async resolveSurveyLogoFileName(schoolId, matId) {
    try {
      if (schoolId > 0) {
        const school = await themeLogoApi.getSchoolDefaultLogo(schoolId)
        const file = headerLogoOf(school)
        if (file) return file
      }
      if (matId > 0) {
        const mat = await themeLogoApi.getMatDefaultLogo(matId)
        return headerLogoOf(mat)
      }
    } catch {
      return ''
    }
    return ''
  }
}
